
export default {
  name: 'PostPollIcon',
  props: {
    stroke: {
      type: String,
      default: null,
    },
    fill: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: '20',
    },
    strokeWidth: {
      type: Number,
      default: 1.67,
    },
  },
  emits: ['onClick'],
  computed: {
    fillAndStrokeClass() {
      let res = '';
      res += 'stroke-' + (this.stroke ? this.stroke : 'neutral-7');
      res += ' fill-' + (this.fill ? this.fill : 'none');
      return res;
    },
  },
};
